import RecorderListContainer from "./RecorderListContainer";

export default RecorderListContainer;
